import { render, staticRenderFns } from "./index2024.vue?vue&type=template&id=03355aa0&scoped=true&"
import script from "./index2024.vue?vue&type=script&lang=js&"
export * from "./index2024.vue?vue&type=script&lang=js&"
import style0 from "./index2024.vue?vue&type=style&index=0&id=03355aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03355aa0",
  null
  
)

export default component.exports